import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import gsap from "gsap";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";
import Button from "./Button"; // Custom Button component
import { SafeHtmlParser } from "./SafeHtmlParser";

const GridLayout1 = ({
	heading,
	industries,
	button,
	colour1,
	colour2,
	colour3,
	colour4,
	colour5,
	colour6,
}) => {
	const colours = [colour1, colour2, colour3];
	const colours2 = [colour4, colour5, colour6];

	const handleMouseEnter = (e, colour) => {
		gsap.to(e.target, { color: colour, duration: 0.1 });
	};

	const handleMouseLeave = (e) => {
		gsap.to(e.target, { color: "#000", duration: 0.1 });
	};

	return (
		<section className="py-5 py-lg-7">
			<Container>
				{/* Heading */}
				<Row>
					<Col className="text-center mb-4">
						<div style={{ color: "#00304B" }}>
							<SafeHtmlParser htmlContent={heading} />
						</div>
					</Col>
				</Row>

				{/* Industries Grid */}
				<Row className="mt-4 g-4 align-items-stretch">
					{/* Left Column */}
					<Col md={6}>
						<Row className="g-4">
							{industries.slice(0, 3).map((industry, i) => {
								const image = industry.industryFields.featuredImage?.localFile
									.childImageSharp.gatsbyImageData
									? getImage(
											industry.industryFields.featuredImage.localFile
												.childImageSharp.gatsbyImageData
									  )
									: null;

								return (
									<Col style={{ minHeight: "100%" }} lg={i === 0 ? 12 : 6}>
										<div
											style={{
												border: "1px solid #CEE4FF",
												borderRadius: "12px",
												overflow: "hidden",
											}}
											key={industry.id}
											className="  h-100 "
										>
											<div className="p-4">
												<h3
													className={`${i === 0 ? "" : "fs-4"}`}
													style={{ color: colours[i] }}
												>
													{industry.title}
												</h3>
												<p className={`${i === 0 ? "pe-5" : ""}`}>
													{industry.industryFields.description}
												</p>
												<div className="d-flex align-items-center">
													<Link
														onMouseEnter={(e) =>
															handleMouseEnter(e, colours[i])
														}
														style={{ color: "black" }}
														onMouseLeave={handleMouseLeave}
														className="outfit-regular text-decoration-none  mb-0 pb-0"
														to={`/industries/${industry.slug}`}
													>
														Learn More{" "}
													</Link>
													<span style={{ color: colours[i] }}>
														<MdKeyboardArrowRight className="fs-5 ms-1" />
													</span>
												</div>
											</div>
											{image && i === 0 && (
												<GatsbyImage
													style={{ height: "300px" }}
													image={image}
													alt={industry.industryFields.featuredImage.altText}
												/>
											)}
										</div>
									</Col>
								);
							})}
						</Row>
					</Col>

					{/* Right Column */}
					<Col md={6}>
						<Row className="g-4">
							{industries.slice(3, 6).map((industry, i) => {
								const image = industry.industryFields.featuredImage?.localFile
									.childImageSharp.gatsbyImageData
									? getImage(
											industry.industryFields.featuredImage.localFile
												.childImageSharp.gatsbyImageData
									  )
									: null;

								return (
									<Col style={{ minHeight: "100%" }} lg={i === 2 ? 12 : 6}>
										<div
											style={{
												border: "1px solid #CEE4FF",
												borderRadius: "12px",
												overflow: "hidden",
											}}
											key={industry.id}
											className="  h-100 "
										>
											<div className="p-4">
												<h3
													className={`${i === 2 ? "" : "fs-4"}`}
													style={{ color: colours2[i] }}
												>
													{industry.title}
												</h3>
												<p>{industry.industryFields.description}</p>
												<div className="d-flex align-items-center">
													<Link
														onMouseEnter={(e) =>
															handleMouseEnter(e, colours2[i])
														}
														style={{ color: "black" }}
														onMouseLeave={handleMouseLeave}
														className="outfit-regular text-decoration-none  mb-0 pb-0"
														to={`/industries/${industry.slug}`}
													>
														Learn More{" "}
													</Link>
													<span style={{ color: colours2[i] }}>
														<MdKeyboardArrowRight className="fs-5 ms-1" />
													</span>
												</div>
											</div>
											{image && i === 2 && (
												<GatsbyImage
													style={{ height: "300px" }}
													image={image}
													alt={industry.industryFields.featuredImage.altText}
												/>
											)}
										</div>
									</Col>
								);
							})}
						</Row>
					</Col>
				</Row>

				{/* View All Button */}
				<Row className="mt-5">
					<Col className="text-center">
						<div className="d-flex justify-content-center">
							<Button
								width="w-100 w-md-auto"
								colour="#0076AF"
								text={button.title}
								link={button.url}
								isOutline={true}
							/>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

// Inline styles

export default GridLayout1;
